import { render } from "./ZNWBadd.vue?vue&type=template&id=083ca3ee&scoped=true"
import script from "./ZNWBadd.vue?vue&type=script&lang=js"
export * from "./ZNWBadd.vue?vue&type=script&lang=js"

import "./ZNWBadd.vue?vue&type=style&index=0&id=083ca3ee&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083ca3ee"]])

export default __exports__